import { DatePicker } from "antd";
import dayjs from "dayjs";
const UiDatePicker = ({
    onChange,
    ...restProp
}) => {
    const handleDateChange = (date) => {
        let formattedDate = null;
        if (date !== null) {
            formattedDate = dayjs(date).format("YYYY-MM-DD");
        }
        onChange(formattedDate);
    };

    return <div>
        <DatePicker
            onChange={handleDateChange}
            format={"DD-MM-YYYY"}
            {...restProp}
        />
    </div>
};
export default UiDatePicker